(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quote-calculator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-quote-calculator]').forEach((calculator) => {
    if (calculator.dataset.ready === 'true') return;
    calculator.dataset.ready = 'true';
    const form = calculator.querySelector('.quote-calculator__form');
    const variant = calculator.querySelector('[data-quote-variant]');
    const area = calculator.querySelector('[data-quote-area]');
    const destination = calculator.querySelector('[data-quote-destination]');
    const result = calculator.querySelector('[data-quote-result]');
    const money = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
    const labels = {
      included: calculator.dataset.labelIncluded,
      consult: calculator.dataset.labelConsult,
      standard: calculator.dataset.labelStandard,
      extended: calculator.dataset.labelExtended,
      quantity: calculator.dataset.labelQuantity,
      destination: calculator.dataset.labelDestination,
      shipping: calculator.dataset.labelShipping,
      total: calculator.dataset.labelTotal,
      area: calculator.dataset.labelArea,
      units: calculator.dataset.labelUnits,
      dimensionError: calculator.dataset.labelDimensionError
    };
    const dimensions = calculator.dataset.productTitle.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    const jointCentimeters = 1;
    const moduleWidth = dimensions ? Number(dimensions[1].replace(',', '.')) + jointCentimeters : 0;
    const moduleHeight = dimensions ? Number(dimensions[2].replace(',', '.')) + jointCentimeters : 0;
    const unitArea = dimensions ? (moduleWidth / 100) * (moduleHeight / 100) : 0;
    const selectedPrice = () => Number((variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant).dataset.price || 0);
    const calculate = () => {
      if (!unitArea) {
        calculator.querySelector('[data-quote-production]').textContent = labels.dimensionError;
        result.hidden = false;
        return;
      }
      const requestedArea = Math.max(0.01, Number(String(area.value).replace(',', '.')) || 0.01);
      const units = Math.ceil(requestedArea / unitArea);
      const coveredArea = unitArea ? units * unitArea : null;
      const unitPrice = selectedPrice();
      const subtotal = unitPrice * units;
      const fixedShipping = destination.value === 'rm' && units <= 200;
      const shipping = fixedShipping ? 2500000 : null;
      const total = shipping === null ? null : subtotal + shipping;
      calculator.querySelector('[data-quote-unit]').textContent = money.format(unitPrice / 100);
      calculator.querySelector('[data-quote-units]').textContent = units.toLocaleString('es-CL');
      calculator.querySelector('[data-quote-coverage]').textContent = coveredArea === null ? labels.consult : `${coveredArea.toLocaleString('es-CL', { maximumFractionDigits: 2 })} m²`;
      calculator.querySelector('[data-quote-subtotal]').textContent = money.format(subtotal / 100);
      calculator.querySelector('[data-quote-shipping]').textContent = shipping === null ? labels.consult : labels.included;
      calculator.querySelector('[data-quote-total]').textContent = total === null ? labels.consult : money.format(total / 100);
      calculator.querySelector('[data-quote-production]').textContent = units <= 50 ? labels.standard : labels.extended;
      result.hidden = false;
      const details = { product_name: calculator.dataset.productTitle, variant_id: variant.value, calculation_mode: 'area', joint_centimeters: jointCentimeters, requested_square_meters: requestedArea, covered_square_meters: coveredArea, quantity: units, destination: destination.value, product_subtotal: subtotal / 100, shipping_amount: shipping === null ? null : shipping / 100, estimated_total: total === null ? null : total / 100 };
      calculator.quoteDetails = details;
      if (window.kaferTrackCalculator) window.kaferTrackCalculator(details);
    };
    form.addEventListener('submit', (event) => { event.preventDefault(); calculate(); });
    calculator.querySelector('[data-quote-continue]').addEventListener('click', () => {
      const details = calculator.quoteDetails;
      const contact = document.querySelector('#ContactForm-body');
      const contactSection = document.querySelector('#ContactForm');
      if (!details || !contact || !contactSection) return;
      const destinationText = destination.selectedOptions[0].textContent.trim();
      const shippingText = details.shipping_amount === null ? labels.consult : money.format(details.shipping_amount);
      const totalText = details.estimated_total === null ? labels.consult : money.format(details.estimated_total);
      const areaText = details.covered_square_meters === null ? labels.consult : `${details.covered_square_meters.toLocaleString('es-CL', { maximumFractionDigits: 2 })} m²`;
      contact.value = `${calculator.dataset.productTitle}\n${labels.area}: ${areaText}\n${labels.units}: ${details.quantity}\n${labels.destination}: ${destinationText}\n${labels.shipping}: ${shippingText}\n${labels.total}: ${totalText}`;
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => contact.focus({ preventScroll: true }), 500);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
